import React from 'react';
import PropTypes from 'prop-types';
import getContent from 'pp-react-l10n';
import axios from 'axios';

export default class ArticleRating extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commentBox: false,
      messageDisplay: false,
      reviewRating: -1,
      reviewComments: "",
    };
    this.onClickYesNo = this.onClickYesNo.bind(this);
    this.showMessage = this.showMessage.bind(this);
    this.onChangeReviewComments = this.onChangeReviewComments.bind(this);
  }

  onChangeReviewComments(e) {
    this.setState({
      reviewComments: e.target.value
    })
  }

  onClickYesNo(review) {
    this.setState({
      commentBox: true,
      reviewRating: review === 'yes' ?  1 : 0,
    });
  }

  showMessage() {
    this.setState({
      messageDisplay: true,
    });
  }

  getCSRFToken()  {
    const body = document.getElementsByTagName('body')[0];
    const csrfToken = body.getAttribute('data-token');
    return csrfToken;
  };


  submitReview() {
    const headingContent = document.getElementById('contentHeading').textContent;
    const self = this;
    const body = {
      entryId: this.props.articleInfo.metadata.entryId,
      language: this.props.locale,
      country: this.props.country,
      locale: this.props.locale,
      "request_type": "FEEDBACK",
      entryTemplateId: "BRCContent",
      docId: this.props.articleInfo.metadata.documentId,
      tenantId: "BRC",
      "request_status": "Success",
      message: this.state.reviewComments,
      userExperience: "merchant",
      "review_rating_value":this.state.reviewRating,
      }
      axios.post('articleReview', {eventParams: body , _csrf : this.getCSRFToken()}).then(function (response) {
      self.showMessage();
    }).catch(function (error) {});
}

  render() {
    const getReviewContent = getContent('staticContent');
    if(this.props.isRatingEnabled){
      return(
        <div>
        {this.state.messageDisplay ?
           <h3 className="review-thanks-message">
           {getReviewContent('brc.reviewThankUMessage')}
          </h3> :
           <div id="articleRating" className="articleRating" >
              <div className="ratingContent">
              <h4 className="review-header-title"> {getReviewContent('brc.contentQuery')}</h4>
              <div>
              <button className={`yesButton ${this.state.reviewRating === 1 ? 'active-yes-no' : ''}`} type="button" onClick= {() => this.onClickYesNo('yes')}> {getReviewContent('brc.reviewYes')}</button>
              <button className={`noButton ${this.state.reviewRating === 0 ? 'active-yes-no' : ''}`} type="button" onClick= {() => this.onClickYesNo('no')}> {getReviewContent('brc.reviewNo')}</button>
              </div>
              </div>
              {this.state.commentBox?   <div className="comments">
                <h4 className="review-textarea-label">{getReviewContent('brc.improveQuery')}</h4>
                <textarea className="commentBox" maxLength={200} value={this.state.reviewComments} onChange={this.onChangeReviewComments}></textarea>
              </div> : ''}
              <button
              className={`ratingSubmit ${!this.state.commentBox ? 'disable-submit-review' : ''}`}
              disabled={!this.state.commentBox}
              onClick= {() => this.submitReview()}>{getReviewContent('brc.reviewSubmit')}</button>
          </div>}
        </div>
      );
    } else {
      return null;
    }
  }

}

ArticleRating.propTypes = {
  articleInfo: PropTypes.object,
  isRatingEnabled: PropTypes.bool
};
